import React = require('react');

import { FlyoutListMenuWidget, MenuButtonWidget, MenuItemInfo } from '@tableau/widgets';

export interface AddContentButtonState {
  readonly isOpen: boolean;
  readonly anchorEl: HTMLElement;
}

export interface AddContentButtonProps {
  readonly buttonText: string;
  readonly testId: string;
  readonly menuItems: MenuItemInfo[];
  readonly onSelect: (value: string) => void;
}

export class AddContentButton extends React.Component<AddContentButtonProps, AddContentButtonState> {
  public constructor(props: AddContentButtonProps) {
    super(props);
    this.state = {
      isOpen: false,
      anchorEl: undefined
    };
  }

  public setAnchorEl = (anchorEl: HTMLElement) => {
    if (!this.state.anchorEl) {
      this.setState({anchorEl});
    }
  }

  public handleSelect = (value: string) => {
    this.setState({ isOpen: false });
    this.props.onSelect(value);
  }

  public render(): JSX.Element {
    const menuId = `${this.props.testId}-menu`;
    return (
      <div>
        <MenuButtonWidget
          aria-controls={menuId}
          isOpen={this.state.isOpen}
          onClick={() => this.setState(prev => ({ isOpen: !prev.isOpen }))}
          ref={this.setAnchorEl}
          testId={this.props.testId}
          tb-test-id={this.props.testId}
          children={this.props.buttonText}
          density="low"
        />
        {
          this.state.isOpen && <FlyoutListMenuWidget
            anchorEl={this.state.anchorEl!}
            allowAutoPosition
            id={menuId}
            menuItemInfos={this.props.menuItems}
            onSelect={this.handleSelect}
            requestCloseAll={() => this.setState({ isOpen: false })}
            menuStyle={{ minWidth: this.state.anchorEl!.getBoundingClientRect().width }}
            testId={`${this.props.testId}-flyout`}
            toggleEl={this.state.anchorEl!}
          />
        }
      </div>
    );
  }
}
